import { render, staticRenderFns } from "./PageCard.vue?vue&type=template&id=91f5fdd0&scoped=true"
import script from "./PageCard.vue?vue&type=script&lang=js"
export * from "./PageCard.vue?vue&type=script&lang=js"
import style0 from "./PageCard.vue?vue&type=style&index=0&id=91f5fdd0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91f5fdd0",
  null
  
)

export default component.exports